import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useObrasState } from "../context/obras-context";
import { useObrasController } from "../context/obras-controller";
import { ObraForm } from "./obra-form";

export const ObraDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useObrasController();
    const { dataResponse, showAddEdit } = useObrasState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Obra ${dataResponse?.id}`;
        return "Adicionar Obra";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <ObraForm />
        </DefaultDrawer>
    );
};
